<template>
    <div class="max-w-7xl mx-auto md:px-6 px-2 py-12">
        <h1 class="text-3xl md:text-4xl font-semibold text-gray-50 mb-6">
            About Us
        </h1>
        <section class="bg-gray-800 rounded-lg shadow-md md:p-8 p-2 mb-6">
      
            <h2 class="text-xl font-semibold text-purple-400 mb-4">
            Who We Are
            </h2>
            <p class="text-gray-300 leading-relaxed">
            At OPPI, we are committed to providing high school students with
            valuable opportunities to grow academically, socially, and professionally.
            Our platform connects students with competitions, awards, and community
            involvement activities, helping them discover new challenges and
            experiences that can shape their futures. Whether you’re looking to build
            your resume or find a scholarship opportunity, we’re here to support you!
            </p>
        </section>
  
        <section class="bg-gray-800 rounded-lg shadow-md md:p-8 p-2 mb-6">
            <h2 class="text-xl font-semibold text-purple-400 mb-4">
            Our Mission
            </h2>
            <p class="text-gray-300 leading-relaxed">
            Our mission is to empower high school students by providing easy access
            to a variety of opportunities. We believe that every student deserves the
            chance to explore their potential and excel in their areas of interest,
            and we aim to facilitate that journey through a user-friendly and
            reliable platform.
            </p>
        </section>
    
        <section class="bg-gray-800 rounded-lg shadow-md md:p-8 p-2">
            <h2 class="text-xl font-semibold text-purple-400 mb-4">
            How It Works
            </h2>
            <ul class="text-gray-300 space-y-4">
            <li class="flex items-start gap-2">
                <svg class="w-5 h-5 text-purple-400" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 2L1 9l4 1v7h14V10l4-1L12 2z" />
                </svg>
                <span>Browse and Filter Opportunities: Explore a wide range of categories like competitions, awards, and more.</span>
            </li>
            </ul>
        </section>
    
        <section class="md:p-8 p-2 mt-12 text-center">
            <h2 class="text-2xl font-semibold text-gray-50 mb-4">Join Us Today!</h2>
            <router-link to="/register">
            <primary-button class="w-auto md:text-base text-sm">Get Started</primary-button>
            </router-link>
        </section>
    </div>
  </template>
  
<script setup>
    import PrimaryButton from '@/components/button/PrimaryButton.vue'
</script>
  
  

<script>
    export default {
        name: 'AboutView'
    }
</script>


<style scoped>
/* Additional styling to match your dark theme */
</style>